<template>
<div class="homepage">
	<div class="banner">
		<img src="/static/images/haierProduct/home_banner.jpg" width="100%">
	</div>
	<div class="productList">
		<div class="productList-item" v-for="(item,index) in list" :key="index" @click="toPage(item)">
			<div class="productList-item-top">
				<img :src="item.image" width="100%">
			</div>
			<div class="productList-item-body">
				<div class="productList-item-body-name">{{item.name}}</div>
				<div class="productList-item-body-info" :class="[getClass(index)]">
					<div class="productList-item-body-info-desc">
						<p v-for="(d,dIndex) in item.desc" :key="dIndex"><Icon type="md-checkmark-circle-outline" class="icon"/>{{d}}</p>
					</div>
				</div>
				<div class="productList-item-body-price">
					<div class="productList-item-body-price-price">
						<span>{{item.price}}</span>{{item.unit}}&nbsp;
					</div>
					<div class="productList-item-body-price-btn">
						<Button type="error" size="large" class="btn">查看详情</Button>
					</div>
				</div>
			</div>
		</div>
		<div class="clear"></div>
	</div>
	<page-fixed-menu></page-fixed-menu>
	<Footer class="homepageFooter"/>
</div>
</template>
<script>
import Footer from '@/components/common/Footer'
import PageFixedMenu from '@/components/common/PageFixedMenu'
import { mapState } from 'vuex'
export default {
	components:{ Footer,PageFixedMenu },
	data(){
		return {
			list:[
				{
					image:'/static/images/haierProduct/home_product_1.jpg',
					name:'平安企业团体雇主责任险',
					desc:['附加24小时意外','附加自费药赔偿','附加伤残赔偿比例调整'],
					price:72,
					unit:'元/人/年起',
					url:'/haierProduct.html#/company-group-employer'
				},
				{
					image:'/static/images/haierProduct/home_product_2.jpg',
					name:'安装维修计划-按人升级版',
					desc:['工伤死亡伤残，百万身价舍我其谁','不限场景赔付，员工随心而用','工伤医疗费用，100%含自费放心治',
					'住院建休津贴，180天安心在家','死亡伤残医疗，发生意外雇主暖人心'],
					price:1200,
					unit:'元/人/年',
					url:'https://b.haierbx.net/ac.html#/installer/index-for-product9'
				},
				{
					image:'/static/images/haierProduct/home_product_3.jpg',
					name:'安装维修计划-按人高端版',
					desc:['工伤死亡伤残，120万身价再度升级','不限场景赔付，员工随心而用','工伤医疗费用，100%含自费放心治',
						'住院建休津贴，180天安心在家','死亡伤残医疗，发生意外雇主暖人心'],
					price:1350,
					unit:'元/人/年',
					url:'https://b.haierbx.net/ac.html#/installer/index-for-product10'
				},
				{
					image:'/static/images/haierProduct/home_product_4.jpg',
					name:'货车雇主责任险-按人投保',
					desc:['日日顺合作方专属优惠方案，行业底价','货车司机意外险的升级，个人雇主也可投保','平安承保，理赔有保障'],
					price:630,
					unit:'元/人/年起',
					url:'/haierProduct.html#/truck-employer/person'
				},
				// {
				// 	image:'/static/images/haierProduct/home_product_5.jpg',
				// 	name:'货车雇主责任险-按车投保',
				// 	desc:['随车按座不记名，最高保额100万','车辆随时更换、增加','平安承保，理赔有保障'],
				// 	price:700,
				// 	unit:'元/座/年起',
				// 	url:'/haierProduct.html#/truck-employer/car'
				// },
				{
					image:'/static/images/haierProduct/home_product_6.jpg',
					name: '实习生团体意外险',
                    desc: ['适合实习生人员的保障方案', '死亡伤残保障限额110万', '医疗费用赔偿限额5万','住院津贴保障100元/天'],
					price:27,
					unit:'元/人/月',
					url:'/haierProduct.html#/trainee-employer',
					login:true,
				},
				{
					image:'/static/images/haierProduct/home_product_7.jpg',
					name:'海尔经销商防控计划',
					desc:['仓储财产保险','雇主责任保险','公众责任保险','门店财产保险'],
					url:'/haier.html'
				},
				{
					image:'/static/images/haierProduct/home_product_8.jpg',
					name:'创客工人雇主保险',
					desc:['适合一线工人的保障方案','意外、疾病全面保障','入职即可购买'],
					price:200,
					unit:'元/人/年',
					url:'/haierProduct.html#/maker-worker',
					login:true,
				},
				{
					image:'/static/images/haierProduct/home_product_9.jpg',
					name:'金控创客保障计划',
					desc:['金控平台专属定制方案','一张保单涵盖N张保单的保障责任'],
					price:570,
					unit:'元/人/年起',
					url:'/haierProduct.html#/jinkong',
					login:true,
				},
				{
					image:'/static/images/haierProduct/home_product_10.jpg',
					name:'仓小微雇主责任保障计划',
					desc:['为仓小微员工提供因公意外伤害风险保障','包括管理文员、保管员','装卸工人、叉车司机'],
					url:'https://b.haierbx.net/ac.html#/storage-v/employer/detail',
				},
				{
					image:'/static/images/haierProduct/guoshou_list.jpg',
					name:'国寿财企业雇主责任险',
					desc:['附加24小时意外','附加自费药赔偿','附加伤残赔偿比例调整'],
					price:70,
					unit:'元/人/年起',
					url:'/haierProduct.html#/company-group-employergs'
				},
			]
		}
	},
	computed:{
		...mapState({
			info:state=>state.common.info
		})
	},
	created () {
		if (location.hostname=='localhost') {

		} else {
			location.href = '/company'
		}
	},
	methods: {
		toPage(item){
			if(item.login&&!this.info.userId){
				window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
			}
			location.href=item.url
		},
		// 获取class，取一行中最大行数作为class
		getClass(index) {
			let n=Math.floor(index/3)
			let max=0;
			for(let i=0;i<3;i++){
				let index=n*3+i;
				if(this.list[index]){
					let length=this.list[index].desc.length
					if(length>max)max=length
				}
			}
			return 'row-'+max
		},
		showOrder () {
			this.$Modal.confirm({
				title: '提示',
				content: '<p>您还有支付未完成的订单</p>',
				onOk: () => {
					
				},
				onCancel: () => {}
			})
		}
	},
}
</script>
<style scoped lang="less">
.homepage{
	.productList{
		width: 1200px;
		margin:0 auto;
		padding-bottom: 50px;
		&-item{
			background: #fff;
			width: 380px;
			margin:25px 10px;
			float: left;
			box-shadow: 0 0 10px #ccc;
			cursor: pointer;
			position: relative;
			&:hover{
				transform:scale(0.95);;
				-ms-transform:scale(0.95);; 	/* IE 9 */
				-moz-transform:scale(0.95);; 	/* Firefox */
				-webkit-transform:scale(0.95);; /* Safari 和 Chrome */
				-o-transform:scale(0.95);; 	/* Opera */
			}
			&-top{
				width: 100%;
				display: inline-block;
			}
			&-body{
				width: 100%;
				padding:20px 16px;
				&-name{
					font-size: 24px;
					color: #222;
				}
				&-info{
					font-size: 16px;
					color: #666;
					line-height: 1;
					height: 150px;
					&.row-3{
						height: 90px;
					}
					&.row-4{
						height: 120px;
					}
					&.row-5{
						height: 150px;
					}
					p{
						margin-top: 13px;
						.icon{
							color: #f46152;
							margin-right: 15px;
						}
					}
				}
				&-price{
					width: 100%;
					&-price{
						display: inline-block;
						font-size: 18px;
						color: #999;
						span{
							color: #f75555;
							font-size: 40px;
						}
					}
					&-btn{
						float: right;
						margin-top: 12px;
						.btn{
							width: 7em;
							background: #f75555;
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/Home.vue